import type { IModalScript, ModalTrigger } from './types'
import { usePlanCheckTrigger } from './triggers/usePlanCheckTrigger'

/**
 * Maps a modal `type` to the hook that decides its visibility. Add a new modal
 * reason by adding a `type` to `IModalScript` and an entry here — existing
 * modals stay untouched.
 */
export const MODAL_TRIGGERS: Record<IModalScript['type'], ModalTrigger> = {
  'plan-check': usePlanCheckTrigger
}
